import { render, staticRenderFns } from "./DashboardSettingsDialog.vue?vue&type=template&id=643db962&"
import script from "./DashboardSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports